// material
import { Box } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

// ----------------------------------------------------------------------

// The wordmark ships in two inks: white lettering for dark surfaces and black for light ones.
const WORDMARK_ON_DARK = '/static/brand/new_logo_dark.png'
const WORDMARK_ON_LIGHT = '/static/brand/new_logo_light.png'
// The olive band mark on its own reads on both surfaces.
const MARK = '/static/brand/minimal_logo.png'

Logo.propTypes = {
  sx: PropTypes.object,
  size: PropTypes.oneOf(['small', 'large']),
  isLoading: PropTypes.bool,
  mark: PropTypes.bool,
}

LogoImage.propTypes = {
  src: PropTypes.string,
}

function LogoImage({ src }) {
  return (
    <Box
      component="img"
      src={src}
      alt="Lidya Genomics"
      sx={{ display: 'block', width: '100%', height: 'auto', borderRadius: '3px' }}
    />
  )
}

export default function Logo({ sx, size = 'small', isLoading = false, mark = false }) {
  // Follow the palette that is actually rendered (not the stored setting) so the
  // lettering always contrasts with the surface behind it.
  const theme = useTheme()
  const logoSrc = theme.palette.mode === 'dark' ? WORDMARK_ON_DARK : WORDMARK_ON_LIGHT

  if (mark) {
    return (
      <Box sx={{ width: 28, ...sx }}>
        <LogoImage src={MARK} />
      </Box>
    )
  }

  if (isLoading) {
    return (
      <Box sx={{ width: { xs: 84, md: 300 }, ...sx }}>
        <LogoImage src={MARK} />
      </Box>
    )
  }

  switch (size) {
    case 'large':
      return (
        <Box sx={{ width: { xs: 84, md: 300 }, ...sx }}>
          <LogoImage src={logoSrc} />
        </Box>
      )
    case 'small':
    default:
      if (window.devicePixelRatio > 1) {
        return (
          <Box sx={{ width: 120, ...sx }}>
            <LogoImage src={logoSrc} />
          </Box>
        )
      }
      return (
        <Box sx={{ width: 120, height: 40, ...sx }}>
          <LogoImage src={logoSrc} />
        </Box>
      )
  }
}
